import React from 'react';
import './unauth-layout.styles.scss';
import UnauthHeader from './unauth-head.component';
import Footer from './footer/footer.component';
import { Desktop, LargeTablet, Mobile, Tablet } from '@/utils/responsiveQueries';
import UnauthHeaderMobile from './unauth-header-mobile.component';

const UnauthLayout = ({ children }) => {
    return (
        <div >
            <Desktop>
                <div className='unauth-layout'>
                    <UnauthHeader />
                    <div className='layout-body'>
                        {children}
                    </div>
                </div>
            </Desktop>
            
            <LargeTablet>
                <div className='unauth-layout'>
                    <UnauthHeader />
                    <div className='layout-body'>
                        {children}
                    </div>
                </div>
            </LargeTablet>

            <Tablet>
                <div className='unauth-layout'>
                    <UnauthHeaderMobile />
                    <div className='mobile-content-container'>
                        {children}
                    </div>
                </div>
            </Tablet>

            <Mobile>
                <div className='unauth-layout'>
                    <UnauthHeaderMobile />
                    <div className='mobile-content-container'>
                        {children}
                    </div>
                </div>
            </Mobile>
        </div>
    )
}

export default UnauthLayout